export default "__VITE_ASSET__b2f3258d__"